import styled, { css } from 'styled-components';

const generalStyles = css`
    font-weight: 700;
    color: #1b1b1b;
`;

export const StyledH1 = styled.h1`
    ${generalStyles}
    font-size: 24px;
    line-height: 30.6px;

    @media screen and (min-width: 577px) {
        font-size: 48px;
        line-height: 61.2px;
    }
`;

export const StyledH2 = styled.h2`
    ${generalStyles}
    font-size: 24px;
    line-height: 30.6px;

    @media screen and (min-width: 577px) {
        font-size: 40px;
        line-height: 51px;
    }
`;

export const StyledH3 = styled.h3`
    ${generalStyles}
    font-size: 20px;
    line-height: 25.5px;

    @media screen and (min-width: 577px) {
        font-size: 30px;
        line-height: 38.25px;
    }
`;

export const StyledSubtitle = styled.p`
    font-weight: 500;
    font-size: 16px;
    line-height: 20.4px;

    @media screen and (min-width: 577px) {
        font-weight: 500;
        font-size: 24px;
        line-height: 30.6px;
    }
`;
